import type { AxiosInstance } from 'axios'
import type { IReferenceDesignService } from "./reference-design.type"
import axios from '@/api/axios'
import type { IReferenceDesignData } from "@/models/reference_design"

export class ReferenceDesignService implements IReferenceDesignService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/reference-designs/'
  }

  async fetchReferenceDesigns(): Promise<IReferenceDesignData[]> {
    return this.axios.get(this.endpoint)
      .then(({ data }) => data)
  }
}

// Default export instantiation of the ReferenceDesignService
const referenceDesignService = new ReferenceDesignService(axios)
export default referenceDesignService